import { getCmsHomeBannerList } from "../../../app/api/getCmsHomeBannerList";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { ICmsHomeBannerResponse, ICMSHomeBannerTypes } from "../../../Orchestrator/Types/Interface/ICmsHomePageBanner";


class GetCmsHomeBannerListAction extends BaseAction<ICMSHomeBannerTypes[], { queryParams: Record<string, any> }> {
  override async run(): Promise<ICMSHomeBannerTypes[] | null> {
    let listOfBanners: ICMSHomeBannerTypes[] = [];
    try {
      const response: IApiResponse<ICmsHomeBannerResponse> = await getCmsHomeBannerList(this.params?.queryParams || {});

      if (response.status === "ok" && response.answer) {
        const HomeBannerArticles = response.answer.data;
        listOfBanners = HomeBannerArticles;
      } else {
        console.warn("Failed to fetch HomeBanner.");
      }
    } catch (error: any) {
      console.error("Error fetching HomeBanner articles:", error);
    } finally {
      updateRecoilState("bannerListResponseAtom", listOfBanners);
      return listOfBanners;
    }
  }
}

export const getCmsHomeBannerListAction = new GetCmsHomeBannerListAction();
